import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { MovimientoBanco } from '../../../models/movimiento-banco';
import { MovimientoBancoService } from '../../../services/movimiento-banco.service';

@Component({
  selector: 'app-movimiento-bancario-modal',
  templateUrl: './movimiento-bancario-modal.component.html',
  styleUrls: ['./movimiento-bancario-modal.component.css'],
  providers:[
    MovimientoBancoService
  ]
})
export class MovimientoBancarioModalComponent implements OnInit {
  @Input() movimiento_id:string;
  public movimiento_show: any;
  public loading:boolean;
  public movimiento_detalle:any;
  public format_decimal:string;
  constructor(
    public movimientoService:MovimientoBancoService,
    public bsModalRef: BsModalRef,
    ) { 
    this.movimiento_show = {};
    this.movimiento_show.formapago = {};
    this.movimiento_show.cuentabancaria = {};
    this.movimiento_show.proveedor = {};
    this.movimiento_show.cliente = {};
    // this.movimiento_show.movimientobancodetalle ={};
    // this.movimiento_show.movimientobancodetalle.cuentacontable ={};
    this.movimiento_detalle = [];
    this.loading = false;
    this.format_decimal = "0,0.00";

  }

  ngOnInit() {
    this.loading = true;
    let p1 = this.getDataMovimiento();
    Promise.all([p1]).then(
      res=>this.loading = false,
      err=> this.loading = false,
    )
  }

  getDataMovimiento(){
    return new Promise((resolve,reject)=>{
    
      this.movimientoService.getById(this.movimiento_id,"?embed=formapago,cliente,proveedor,cuentabancaria,movimientobancodetalle?embed=cuentacontable").subscribe(
        res=>{
          this.movimiento_show = res.data;
          this.movimiento_detalle = this.movimiento_show.movimientobancodetalle; 
          resolve();
        },err=>{
          reject(err);
        }
      );
      
      
    });
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/movimiento-bancario-modal/movimiento-bancario-modal.component.ts